import PropTypes from 'prop-types';
import styles from './page-title.css';


const PageTitle = ({
  text,
  reducedMarginBottom,
  className,
}) => (
  <div className={`${styles.container} ${reducedMarginBottom ? styles.reducedMarginBottom : ''} ${className || ''}`}>
    {text || <>&nbsp;</>}
  </div>
);

PageTitle.propTypes = {
  text: PropTypes.string,
  reducedMarginBottom: PropTypes.bool,
  className: PropTypes.string,
};

export default PageTitle;
